<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <!-- <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="list">刷新</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleEdit($event)">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="loading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        row-key="id"
        default-expand-all
        :tree-props="{ children: 'children' }"
      >
        <el-table-column prop="name" width="200" label="名称">
          <template #default="{ row }">
            <span>{{ row.id }}.&nbsp;</span>
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="id" label="编号"></el-table-column> -->

        <!-- <el-table-column prop="parentId" label="上级ID"></el-table-column> -->

        <el-table-column prop="icon" label="图标">
          <template #default="{ row }">
            <el-image
              :src="row.icon"
              :preview-src-list="[row.icon]"
              style="max-width: 50px; max-height: 50px"
            />
          </template>
        </el-table-column>

        <!-- <el-table-column prop="type" label="type"></el-table-column> -->

        <el-table-column prop="description" label="描述"></el-table-column>

        <el-table-column prop="sortNo" label="排序"></el-table-column>

        <el-table-column prop="appraiseConfig" label="价格(PH)">
          <template #default="{ row }">
            <span v-if="row.appriaseConfig">{{ row.appriaseConfig.price || "-" }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="appraiseConfig" label="价格(AUS)">
          <template #default="{ row }">
            <span v-if="row.appriaseConfig">{{ row.appriaseConfig.ausPrice || "-" }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="appraiseConfig" label="价格(MYS)">
          <template #default="{ row }">
            <span v-if="row.appriaseConfig">{{ row.appriaseConfig.mysPrice || "-" }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="appraiseConfig" label="鉴定积分">
          <template #default="{ row }">
            <span v-if="row.appriaseConfig">{{ row.appriaseConfig.score || "-" }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!--
        <el-table-column prop="status" label="状态"></el-table-column>
        -->
        <el-table-column prop="createTime" label="创建时间">
          <template #default="{ row }">{{ row.createTime | formatDate }}</template>
        </el-table-column>

        <el-table-column prop="updateTime" label="更新时间">
          <template #default="{ row }">{{ row.updateTime | formatDate }}</template>
        </el-table-column>

        <el-table-column label="操作" width="220">
          <template #default="{ row }">
            <el-button size="mini" type="primary" @click="handleEdit(row)">编辑</el-button>
            <el-button v-if="row.parentId > 0" size="mini" type="success" @click="showConfig(row)"
              >配置</el-button
            >
            <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty />
        </template>
      </el-table>
    </div>

    <edit ref="editRef" @success="list" />
    <config ref="configRef" @success="list" />
  </section>
</template>

<script>
import Edit from "./components/Edit";
import Config from "./components/Config";
import mainHeight from "@/utils/mainHeight";
export default {
  name: "Tag",
  components: { Edit, Config },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      loading: true,
      filters: {},
      selectedRows: [],
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      this.loading = true;
      const params = Object.assign(this.filters, {});
      try {
        this.results = await this.axios.get("base:/api/admin/tag/legit_check_tags", {
          params: params,
        });
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.loading = false;
      }
    },
    handleEdit(row) {
      if (row.id) {
        this.$refs.editRef.showEdit(row);
      } else {
        this.$refs.editRef.showEdit();
      }
    },
    handleDelete(row) {
      const me = this;
      this.$confirm("Are you sure?", "Alert", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          me.axios
            .post(`/api/admin/tag/delete/${row.id}`)
            .then((data) => {
              me.$message.success("删除成功");
              me.list();
            })
            .catch((rsp) => {
              me.$notify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {});
    },
    showConfig(row) {
      this.$refs.configRef.show(row);
    },
  },
};
</script>

<style lang="scss" scoped></style>
